import { fireBaseAuth, firebaseDb } from "../../firebase";
import * as actionTypes from "./actionTypes";

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const authSuccess = (authenticated) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    authenticated: authenticated,
  };
};

export const passwordResetSuccess = (passwordReset) => {
  return {
    type: actionTypes.AUTH_PASSWORD_RESET,
    passwordReset: passwordReset,
  };
};

export const setUser = (user) => {
  return {
    type: actionTypes.SET_USER,
    user: user,
  };
};

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error,
  };
};

export const passwordResetFail = (passwordResetError) => {
  return {
    type: actionTypes.AUTH_PASSWORD_RESET_FAIL,
    passwordResetError: passwordResetError,
  };
};

export const authFailClear = (error) => {
  return {
    type: actionTypes.AUTH_FAIL_CLEAR,
    error: null,
  };
};

const removeStravaLocalStorageItems = () => {
  localStorage.removeItem("athlete_id");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("access_token");
  localStorage.removeItem("expirationDate");
};

export const logout = () => {
  fireBaseAuth.signOut();
  removeStravaLocalStorageItems();
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

export const checkAuthTimeout = (expirationTime) => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(logout());
    }, expirationTime * 1000);
  };
};

export const authCheckState = () => {
  return (dispatch) => {
    fireBaseAuth.onAuthStateChanged(function (user) {
      dispatch(authSuccess(user !== null));
      if (user) {
        console.log("user.uid", user.uid);
        firebaseDb
          .collection("User")
          .where("userId", "==", user.uid)
          .get()
          .then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              // doc.data() is never undefined for query doc snapshots
              console.log(doc.id, " => ", doc.data());
              dispatch(setUser(doc.data()));
            });
          })
          .catch(function (error) {
            console.log("Error getting documents: ", error);
          });
      } else {
      }
    });
  };
};

export const login = (email, password) => {
  return (dispatch) => {
    dispatch(authStart());
    fireBaseAuth
      .signInWithEmailAndPassword(email, password)
      .then((user) => {
        var currentUser = fireBaseAuth.currentUser;
        dispatch(authSuccess(user !== null));
      })
      .catch((error) => {
        var errorMessage = error.message;
        dispatch(authFail(errorMessage));
      });
  };
};

export const passwordReset = (email) => {
  return (dispatch) => {
    dispatch(authStart());
    fireBaseAuth
      .sendPasswordResetEmail(email)
      .then(() => {
        dispatch(passwordResetSuccess(true));
      })
      .catch((error) => {
        var errorMessage = error.message;
        console.log(errorMessage);
        dispatch(passwordResetFail(errorMessage));
        dispatch(passwordResetSuccess(false));
      });
  };
};

export const setAuthRedirectPath = (path) => {
  return {
    type: actionTypes.SET_AUTH_REDIRECT_PATH,
    path: path,
  };
};

export const register = (
  firstName,
  lastName,
  idNumber,
  emailAddress,
  password,
  gender,
  cellNumber
) => {
  console.log(
    firstName,
    lastName,
    idNumber,
    emailAddress,
    password,
    gender,
    cellNumber
  );
  return (dispatch) => {
    dispatch(authStart());
    fireBaseAuth
      .createUserWithEmailAndPassword(emailAddress, password)
      .then((user) => {
        var currentUser = fireBaseAuth.currentUser;
        firebaseDb
          .collection("User")
          .add({
            userId: currentUser.uid,
            firstName,
            lastName,
            idNumber,
            emailAddress,
            gender,
            cellNumber,
          })
          .then((item) => {
            console.log(item);
          })
          .catch(console.log);
      })
      .catch((error) => {
        var errorMessage = error.message;
        dispatch(authFail(errorMessage));
      });
  };
};
